/*
 * File: /src/store/modules/leadTypes.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import LeadTypeService from 'src/services/leadTypeService';

const state = {
  leadTypes: undefined
};

const getters = {
  getLeadTypes: (state) => state.leadTypes,
};
const actions = {
  async fetchLeadTypes({ commit, state, rootGetters }) {
    // Only load the data once
    if (state.leadTypes == undefined) {
      return LeadTypeService.fetchAll()
      .then(r => {
        commit('setLeadTypes', r.data);
      });
    }
  },
  async reloadLeadTypes({ commit }) {
    const r = await LeadTypeService.fetchAll();
    commit('setLeadTypes', r.data);
    return r.data;
  },
  unloadLeadTypes({ commit }) {
    commit('setLeadTypes', undefined);
  }
};
const mutations = {
  setLeadTypes(state, types) {
    state.leadTypes = types;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
